import { useEffect } from 'react';
import { useAuth } from '@chainlit/react-client';
import Page from 'pages/Page';


export default function AWatch() {
  const { isAuthenticated } = useAuth();

  useEffect(() => {
    // Place any post-login data bootstrapping here
  }, [isAuthenticated]);

  return (
    <Page>
         <div className="p-8 space-y-6">
      <h1 className="text-2xl font-semibold tracking-tight">AWatch Dashboard</h1>
      <div className="grid gap-6 md:grid-cols-2 xl:grid-cols-3">
        <div className="rounded-xl border border-border/60 bg-card/60 backdrop-blur p-4">
          <h2 className="text-sm font-medium mb-2">Active Incidents</h2>
          <div className="text-3xl font-semibold">0</div>
        </div>
        <div className="rounded-xl border border-border/60 bg-card/60 backdrop-blur p-4">
          <h2 className="text-sm font-medium mb-2">Alerts (24h)</h2>
          <div className="text-3xl font-semibold">0</div>
        </div>
        <div className="rounded-xl border border-border/60 bg-card/60 backdrop-blur p-4">
          <h2 className="text-sm font-medium mb-2">MTTR (hrs)</h2>
          <div className="text-3xl font-semibold">—</div>
        </div>
      </div>

      <div className="rounded-xl border border-border/60 bg-card/60 backdrop-blur p-6">
        <h2 className="text-sm font-medium mb-4">Recent Activity</h2>
        <div className="text-xs text-muted-foreground">No activity yet.</div>
      </div>
    </div>
    </Page>
   
  );
}